import { BaseService } from './BaseService'
const SELECTED_MISSION_PATH = '/mission-detail'
const MISSIONS_PATH = '/missions'
const MY_MISSIONS_PATH = '/my-missions'
const START_MISSION_PATH = '/select-mission'
const PUBLIC_EVENTS_PATH = '/special-modes/public'
/* eslint-disable */ 
class MissionService extends BaseService {
    getSelectedMissionId (missionId, locationId) {
      return this.get(SELECTED_MISSION_PATH + '/' + missionId + '/' + locationId).then(response => {
        return response
      })
    }
    getMissions (formData) {
      return this.post(MISSIONS_PATH, formData).then(response => {
        return response
      })
    }
    getMyMissionList () {
      return this.get(MY_MISSIONS_PATH)
    }
    getStartMission (formData) {
      return this.post(START_MISSION_PATH, formData).then(response => {
        return response
      })
    }
    getPublicEvents () {
      return this.get(PUBLIC_EVENTS_PATH).then(response => {
        return response
      })
    }
  }
  export default new MissionService()
  /* eslint-disable */ 
